/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import { useEffect, useState } from "react";
import DataTable from "components/Tables/DataTable";
import Filtros from "components/filtros/filtros";
import { commonChips } from "constants/common/pageHeaderChips";
import PageHeader from "components/pageHead/pageHead";
import Layout from "components/LayoutContainers/mainLayout";
import { GeneralFetch } from "Api/generalFetch/generalFetch";
import LinearProgressComponent from "components/linearProgress/linearProgress";
import { nearMissData } from "./data/tableDataGenerator";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { RefetchData } from "schemas";
import { classADataExporter } from "utils/exporter/excel/classAExporter";
import { locais } from "constants/common/formConstants";
import { estados } from "constants/common/formConstants";
import { format } from "date-fns";
import { booleanOptions } from "constants/common/formConstants";
import { getUsers } from "hooks/users/getUsers";
import { FileExcelOutlined } from '@ant-design/icons';
import { Button } from '@mui/material';
import { useParams } from "hooks/common/useQueryParams";
import { createDrawerState, DrawerSchema } from "schemas";

function Tables() {
  const [selected, setSelected] = useState('nearmisses')
  const [paging, setPaging] = useState({
    perPage: 10, page: 1, total: 50
  })
  const [tableData, setTableData] = useState([])
  const [loadingExport, setLoading] = useState(false)
  const { fetchData, loading } = GeneralFetch()
  const { rows, columns } = nearMissData({ data: tableData, object: selected })
  const [formData, setFormData] = useState({})
  const refetchTableData = useRecoilValue(RefetchData)
  const { exportData } = classADataExporter()
  const { users, loading: loadingUSers } = getUsers()
  const { urlParamiters } = useParams()
  const { id } = urlParamiters()
  const setOpen = useSetRecoilState(DrawerSchema)

  useEffect(() => {
    setTableData([])
    const fetchDataAsync = async () => {
      await fetchData({ ...formData, dataBase: selected, perPage: paging.perPage, page: paging.page }, `getTableData${id ? '?id=' + id : ""}`, 'post', 'tableData').then((resp) => {
        setPaging((prev) => ({ ...prev, total: resp?.total }))
        setTableData(resp?.tableData)
        if (id !== null && resp?.tableData.length > 0) setOpen(createDrawerState({ open: true, object: selected, data: resp?.tableData?.find(x => x.hash === id) }))
      })
    }

    void fetchDataAsync();
  }, [selected, paging.page, paging.perPage, formData, refetchTableData])

  async function handleExport() {
    setLoading(true)
    await fetchData({ ...formData, dataBase: selected }, `getTableData?export=true`, 'post', 'tableData').then(async (resp) => {
      let toExport = resp?.data?.map((item) => {

        return {
          ...item,
          local: locais?.find(x => x?.value == item?.local)?.label,
          stop_card: booleanOptions?.find(x => x.value == item?.stop_card)?.label,
          estado: estados?.find(x => x.value == item?.estado)?.label,
          reportado_por: users?.find(x => x.value == item?.reportado_por)?.label,
          data: format(new Date(item?.dataAcontecimento), 'dd-MM-yyyy'),
        }
      })

      exportData(toExport, `${commonChips?.find(chip => chip.value === selected)?.label} de ${(formData?.classe != 'todos' && formData?.classe != undefined) ? 'categoria ' + formData?.classe : 'todas categorias'} ${formData?.stopCard == 1 ? 'com stop card' : ''}`)
    }).finally(() => {
      setLoading(false)
    })
  }

  return (
    <Layout>

      <PageHeader selected={selected} setSelected={setSelected} chips={commonChips} showAddBtn={true} />

      <Grid container marginTop={"0px"} spacing={6}>
        <Grid item xs={12}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={0}
              px={0}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              {(loading || loadingUSers) && <LinearProgressComponent />}
              <div style={{ width: "100%", display: "flex", justifyContent: "space-between", margin: "20px 10px" }} >
                <MDTypography variant="h6" color="white" >
                  Listar {commonChips?.find(chip => chip.value === selected)?.label}
                </MDTypography>
                <div style={{ display: "flex" }} >
                  <Button
                    disabled={loadingExport}
                    onClick={async () => handleExport()}
                    variant="contained"
                    style={{ margin: "-5px", color: "#000", background: "#fff", height: "35px" }}
                    startIcon={<FileExcelOutlined />}
                  >
                    Exportar dados
                  </Button>
                  <div style={{ width: "20px" }} ></div>
                </div>
              </div>
            </MDBox>
            <MDBox pt={3} ml={"18px"} >
              <Filtros owners={users} formData={formData} setFormData={setFormData} />
            </MDBox>
            <MDBox pt={3}>
              <DataTable
                table={{ columns: columns?.filter(x => x.table == true), rows }}
                showTotalEntries={false}
                noEndBorder
                setPaging={setPaging}
                paging={paging}
              />
            </MDBox>
          </Card>
        </Grid>
      </Grid>
    </Layout >
  );
}

export default Tables;
